export const getEmailConfigs = (dateString: string) => ({
    us: {
        contactListId: ['2029215499'],
        fields: [
            {
                id: '4423',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: false,
            },
            {
                id: '11150',
                type: 'multiple',
                value: ['28'],
                overwrite: false,
            },
            {
                id: '13759',
                type: 'text',
                value: dateString,
                overwrite: false,
            },
        ],
    },
    ca: {
        contactListId: ['360951019'],
        fields: [
            {
                id: '4424',
                type: 'single',
                value: 1,
                overwrite: true,
            },
            {
                id: '31',
                type: 'single',
                value: 1,
                overwrite: false,
            },
            {
                id: '11150',
                type: 'multiple',
                value: ['28'],
                overwrite: false,
            },
            {
                id: '13759',
                type: 'text',
                value: dateString,
                overwrite: false,
            },
        ],
    },
});
